import camelcase from 'camelcase-keys';

export default function replaceKeysWithCamelCase(object: Record<string, any>) {
  return camelcase(object, {
    deep: true,
    exclude: [
      /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/, // Date format
      /^(?![a-z][a-z0-9]*([_-][a-z0-9]+)+$).*$/, // Exclude keys that are NOT snake_case or kebab-case
    ],
  });
}
